<template>
  <div class="check-uid-con">
    <div :class="bindInputClass">
      <input
        id="check-uid-input"
        ref="check-uid-input"
        v-model="serverUid"
        autocomplete="off"
        :type="inputType"
        :inputmode="inpuTmode"
        :placeholder="placeholderText"
        @input="handleInput"
        @blur="handleBlur"
        @focus="handleFocus"
        @keyup.enter="handleBlur"
        :class="bindUidClass"
        :style="bindInputStyle"
      />
    </div>
  </div>
</template>

<script>
  import styleConfiguration from '@/mixins/detail/styleConfiguration'
  import { autoInputUid } from '@page_detail/firebase'
  import { mapGetters, mapMutations, mapState } from 'vuex'
  import { hexToRgba } from '@/utils/hexToRgba'
  import { storage } from '@/utils/storage'
  export default {
    mixins: [styleConfiguration],
    data() {
      return {
        serverUid: '',
        inpuTmode: 'numeric',
        inputType: 'tel',
        validator: {
          isInInput: false, // 是否在输入中
          isError: false, // 验证错误
          isSuccess: false, // 验证成功
          isLoading: false, // 验证中
          errorCode: 0,
        },
        inputmode: {
          tel: 'numeric',
          text: 'email',
        },
      }
    },
    computed: {
      ...mapState(['isDesktop', 'isMobile', 'gameName']),
      ...mapState('detail', ['userId']),
      ...mapGetters(['isNotCheckGames', 'selectedUidKey', 'isMySoulLand3d']),
      placeholderText() {
        if (this.isMySoulLand3d) {
          return this.$t(`${this.gameName}.uid_placeholder`)
        }
        return this.$t(`publicDetails.repeat_uid_title`, {
          uid: 'UID',
        })
      },

      bindInputStyle() {
        return {
          backgroundColor: this.skuBackColor.backgroundColor,
          borderColor: this.skuBackColor.borderColor,
          color: this.mFontColor.color,
          '--placeholderColor': hexToRgba(this.mFontColor.color),
        }
      },
      bindInputClass() {
        const defaultClass = ['special-check-uid-content']
        let device = []

        if (this.isDesktop) {
          device.push(`${defaultClass[0]}-desktop`)
        }
        if (this.isMobile) {
          device.push(`${defaultClass[0]}-mobile`)
        }
        return defaultClass.concat(device)
      },
      bindUidClass() {
        const classnames = ['check-uid-input']
        let classTypes = []
        if (this.isDesktop) {
          classTypes.push('desktop-input')
        }
        return classnames.concat(classTypes)
      },
    },
    watch: {},
    mounted() {
      this.getCacheUid()
    },
    methods: {
      ...mapMutations([
        'detail/setCheckffuid',
        'detail/setRenderCheckffuid',
        'detail/setUidValidator',
        'detail/setServerUserId',
      ]),

      getCacheUid() {
        const cacheUid = storage.get(this.selectedUidKey) || null
        if (!cacheUid) return

        this.serverUid = cacheUid
        this['detail/setServerUserId'](cacheUid)
        autoInputUid(this.gameName)
      },

      handleCheck({
        isInInput = false,
        isError = false,
        isSuccess = false,
        isLoading = false,
        errorCode = 0,
      } = {}) {
        this.validator = {
          isInInput,
          isError,
          isSuccess,
          isLoading,
          errorCode,
        }
        this['detail/setUidValidator'](this.validator)
      },
      handleInput() {
        this.serverUid = this.serverUid.replace(/\D/g, '')
      },
      handleBlur() {
        if (this.$refs['check-uid-input']) {
          this.$refs['check-uid-input'].blur()
        }

        this['detail/setServerUserId'](this.serverUid)
      },
      handleFocus() {},
    },
  }
</script>

<style scoped lang="scss" src="./styles.scss"></style>
<style lang="scss" scoped>
  @media screen and (min-device-width: 1080px) {
    @import './styles_pc.scss';
  }
</style>
